import { IButtonProps } from "../../interfaces/types";
import IconPreview from "../icons/IconPreview";
import { forwardRef } from "react";

const ButtonPreview = forwardRef(
  (
    props: IButtonProps,
    ref: React.LegacyRef<HTMLButtonElement> | undefined,
  ) => {
    const { ...rest } = props;
    return (
      <button
        {...rest}
        className="btn btn-sm btn-outline-primary-subtle col d-flex flex-column align-items-center gap-1 py-2"
        title="Se foreløbig erklæring"
        ref={ref}
      >
        <IconPreview />
        <small>Forhåndsvisning</small>
      </button>
    );
  },
);

export default ButtonPreview;
